// 商机状态（1、未约访，2、未跟进，3、正在跟进，4、商机流失，5、已成交）
export type OpportunityStatus = 'ALL' | 'IN_PROGRESS' | 'DELAY' | 'CLOSED_WON' | 'LOSS';
export const OPPOTUNITY_STATUS_GROUP = {
  ALL: [1, 2, 3, 4, 5, 6, 7],
  IN_PROGRESS: [1, 2, 6, 7],
  DELAY: [],
  CLOSED_WON: [4, 5],
  LOSS: [3],
};

// 销售阶段（1、联系约访，2、上门勘测，3、确认合同4、安排发货，5、上门安装）
export enum SALE_STATUS {
  CONTACT = 1,
  SURVEY = 2,
  CONTRACT = 3,
  SHIPMENT = 4,
  INSTALL = 5,
}

export enum IMPORTANCE_LEVEL {
  High = 1,
  Mid = 2,
  Low = 3,
}

// 期望安装时间（1、Immediately，2、In the next 4 weeks，3、In the next 3 months，4、Over 3 months/Just looking for a ballpark price）
export enum INSTALL_TIME {
  'Immediately' = 1,
  'In the next 4 weeks' = 2,
  'In the next 3 months' = 3,
  'Over 3 months/Just looking for a ballpark price' = 4,
}

export const BASEURL_USERCENTER = '/user-center';
